import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { Subject } from 'rxjs';

const BACKEND_URL = environment.apiUrl + '/bet';
const BACKEND_URL_CASINO = environment.apiUrl + '/casino';
const SESSION_URL = environment.apiUrl + '/session';

@Injectable({ providedIn: "root" })
export class BetService {
    private bets: any[] = [];
    private mBook: any[] = [];
    private uBets: any[] = [];
    private uEBets: any[] = [];
    private cpl: any[] = [];
    private casinoBets: any[] = [];
    private jantriBets: any[] = [];
    private jantri: any[] = [];
    private jantriL: any;
    private betsUpdated = new Subject<{ bets: any[] }>();
    private mBookUpdated = new Subject<{ mBook: any[] }>();
    private uBetsUpdated = new Subject<{ uBets: any[], totalCount: number }>();
    private uEBetsUpdated = new Subject<{ uEBets: any[] }>();
    private cplUpdated = new Subject<{ cpl: any[] }>();
    private casinoBetsUpdated = new Subject<{ casinoBets: any[] }>();
    private jantriBetsUpdated = new Subject<{ jantriBets: any[] }>();
    private jantriLUpdated = new Subject<{ result: any }>();
    private jantriUpdated = new Subject<{ jantri: any[] }>();
    private allBetsList =  new Subject<{}>()
    constructor(private http: HttpClient) { }

    setOddsBet(betData) {
        if (betData.oddsType == 'Odds') {
            return this.http.post(BACKEND_URL + '/setOddsBet', betData);
        }
        else if (betData.oddsType == 'BM') {
            return this.http.post(BACKEND_URL + '/setBMBet', betData);
        }
        else if (betData.oddsType == 'Toss') {
            return this.http.post(BACKEND_URL + '/setTossBet', betData);
        }
        else if (betData.oddsType == 'Fancy') {
            // console.log(betData);
            return this.http.post(BACKEND_URL + '/setSessionBet', betData);
        }
        else if (betData.oddsType == 'Khado') {
            return this.http.post(BACKEND_URL + '/setKhadoBet', betData);
        }
    }

    getSessionMaxPrice(eventId) {
        return this.http.get<{ message: string, result: any, status: string }>(SESSION_URL + '/getSessionMaxPrice/' + eventId);
    }

    getEventBets(eventId) {
        this.http.get<{ message: string, result: any, status: string }>(BACKEND_URL + '/getEventBets/' + eventId)
            .subscribe((data) => {
                this.bets = data.result;
                this.betsUpdated.next({
                    bets: [...this.bets]
                });
            });;
    }

    getUpdateBetsListner() {
        return this.betsUpdated.asObservable();
    }

    getMatchBook() {
        this.http.get<{ message: string, result: any, status: string }>(BACKEND_URL + '/getMatchBook')
            .subscribe((data) => {
                this.mBook = data.result;
                this.mBookUpdated.next({
                    mBook: [...this.mBook]
                });
            });;
    }

    getUpdateMatchBookListner() {
        return this.mBookUpdated.asObservable();
    }

    getUserBets(pagesize, page, type, start, end) {
        let query;
        if (start && end) {
            query = `?pagesize=${pagesize}&page=${page}&type=${type}&start=${start}&end=${end}`;
        }
        else {
            query = `?pagesize=${pagesize}&page=${page}&type=${type}`;
        }

        this.http.get<{ message: string, result: any, maxCount: number, status: string }>(BACKEND_URL + '/getUserBets' + query)
            .subscribe((data) => {
                this.uBets = data.result;
                this.uBetsUpdated.next({
                    uBets: [...this.uBets],
                    totalCount: data.maxCount
                });
            });;
    }

    getUpdateUserBetsListner() {
        return this.uBetsUpdated.asObservable();
    }

    getClientPL() {
        this.http.get<{ message: string, result: any, status: string }>(BACKEND_URL + '/getClientPL')
            .subscribe((data) => {
                this.cpl = data.result;
                this.cplUpdated.next({
                    cpl: [...this.cpl]
                });
            });;
    }

    getUpdateClientPLListner() {
        return this.cplUpdated.asObservable();
    }

    getUserEBets(eventId, type) {
        const query = `?type=${type}`;
        this.http.get<{ message: string, result: any, status: string }>(BACKEND_URL + '/getUserEBets/' + eventId + '' + query)
            .subscribe((data) => {
                this.uEBets = data.result;
                this.uEBetsUpdated.next({
                    uEBets: [...this.uEBets]
                });
            });
    }

    getUpdateUserEBetsListner() {
        return this.uEBetsUpdated.asObservable();
    }

    setCasinoBet(betData) {
        return this.http.post(BACKEND_URL_CASINO + '/setCasinoBet', betData);
    }

    getCasinoBets(eventId) {
        this.http.post<{ message: string, result: any, status: string }>(BACKEND_URL_CASINO + '/getCasinoBets/' + eventId, {})
            .subscribe((data) => {
                this.casinoBets = data.result;
                this.casinoBetsUpdated.next({
                    casinoBets: [...this.casinoBets]
                });
            });;
    }

    getUpdateCasinoBetsListner() {
        return this.casinoBetsUpdated.asObservable();
    }

    setDmdCasinoBet(betData) {
        return this.http.post(BACKEND_URL + '/setDmdCasinoBet', betData);
    }

    setJantriBet(betData) {
        return this.http.post(BACKEND_URL_CASINO + '/setJantriBet', betData);
    }

    getJantriBets(eventId) {
        this.http.post<{ message: string, result: any, status: string }>(BACKEND_URL_CASINO + '/getJantriBets/' + eventId, {})
            .subscribe((data) => {
                this.jantriBets = data.result;
                this.jantriBetsUpdated.next({
                    jantriBets: [...this.jantriBets]
                });
            });;
    }

    getUpdateJantriBetsListner() {
        return this.jantriBetsUpdated.asObservable();
    }

    getLiveJantri(eventId) {
        this.http.get<{ message: string, result: any, status: string }>(BACKEND_URL_CASINO + '/getLiveJantri/' + eventId)
            .subscribe((data) => {
                this.jantriL = data;
                this.jantriLUpdated.next({
                    result: this.jantriL.result
                });
            });;
    }

    getUpdateLiveJantriListner() {
        return this.jantriLUpdated.asObservable();
    }

    getJantri(sportId) {
        this.http.get<{ message: string, result: any, status: string }>(BACKEND_URL_CASINO + '/getCJantri/' + sportId)
            .subscribe((data) => {
                this.jantri = data.result;
                this.jantriUpdated.next({
                    jantri: [...this.jantri]
                });
            });;
    }

    getUpdateJantriListner() {
        return this.jantriUpdated.asObservable();
    }


    setAllBets(){
        this.http.get(BACKEND_URL + '/get-all-bets').subscribe((res:any)=>{
            this.allBetsList.next( res?.result || [])
        });
    }

    getAllBets(){
        return this.allBetsList.asObservable();
    }
}